define('responsive-gameday/views/render/ScoringPlaysViewRender',['require','exports','module','./ViewRender','../../helpers/PitchListToggle','Wax/get!view-templates/playByPlay/scoring','Wax/get!view-templates/playByPlay/play','Wax/get!view-templates/playByPlay/pitch'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        PitchListToggle = require("../../helpers/PitchListToggle"),
        Superclass;

    function ScoringPlaysViewRender(){
        Superclass.constructor.call(this,
            require( 'Wax/get!view-templates/playByPlay/scoring' ),{
                playView    : require( "Wax/get!view-templates/playByPlay/play" ),
                pitchView   : require( "Wax/get!view-templates/playByPlay/pitch" )
            }
        );
    }
    ViewRender.spawn(ScoringPlaysViewRender).define({
        setPitchToggler : function(controller){
            var pitchToggler = this.pitchToggler = this.pitchToggler || new PitchListToggle(controller);

            pitchToggler.className = 'pitches_visible';
            pitchToggler.on(controller.childWrapper || controller.view, '.play .detail');

            this.viewState.pitchState=pitchToggler.pitchesState;

        }
    });

    Superclass=ScoringPlaysViewRender.superclass;

    return ScoringPlaysViewRender;
});
